import React from "react"
import AppDialog from "../../../components/Common/AppDialog"

import '../order.css';

const ReopenOrder = (props) => {
    return (
        <AppDialog
            open={props.open}
            close={() => props.close()}
            title={'Reopen order'}
            titleIcon={'complete'}
            positiveTitle={'Reopen order'}
            positivePress={() => props.submit()}
            positiveButtonStyle={{ backgroundColor: '#44d62c', color: 'white', border: '1px solid #44d62c' }}
            negativePress={() => props.close()}
            negativeTitle={'Cancel'}
            width={'30%'}
        >
            <div style={{ fontSize: 14, color: '#282828', lineHeight: 1.5 }}>
                Reopen this closed order to its previous status before it was closed.
                Points awarded at close stay with the customer until you cancel the order.
            </div>
        </AppDialog>
    )
}

export default ReopenOrder;
